/* eslint-disable */
import styled, { css } from 'styled-components';

const Container = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
`;

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${props => props.theme.spacers.L};
    flex-wrap: nowrap;

    &:last-child {
        margin-bottom: 0;
    }
`;

const Cell = styled.div`
    display: inline-flex;
    ${({ theme }) => css(theme.typography.Paragraph)}
    ${({ bold }) => bold
        && css`
            font-weight: 800;
        `}
`;

const TaxNote = styled.span`
    ${({ theme }) => css(theme.typography.Paragraph)}
    margin-left: 5px;
    display: inline;
    align-self: center;
`;

export {
    Container,
    Cell,
    Row,
    TaxNote,
}